import { FC } from 'react'
import StreamAdditionalCoursePeriodFields from './StreamAdditionalCoursePeriodFields'
import StreamAdditionalCourseDiscountFields from './StreamAdditionalCourseDiscountFields'
import type { CrmLinkDiscountMode } from '../../../../../discountMode.utils'
import type { MonthlyCourseLinkPeriodUnit } from '../../../../../monthlyCourseLinkDiscount.utils'

export type StreamAdditionalCourseFieldsProps = {
  tariff: ICourseTariff
  isPeriodFixed: boolean
  periodUnit: MonthlyCourseLinkPeriodUnit
  periodValue: number | null
  discount: number
  discountMode: CrmLinkDiscountMode | null
  price: number
  streamPeriodValue: number | null
  streamBasePrice: number
  onTogglePeriodFixed: (checked?: boolean) => void
  onChangePeriodUnit: (value: MonthlyCourseLinkPeriodUnit) => void
  onChangeValue: (value: string | number | null) => void
  onChangeUnfixedValue: (value: number) => void
  onChangeDiscount: (value: string | number | null) => void
  onDiscountModeChange: (mode: CrmLinkDiscountMode | null) => void
  onChangePrice: (value: string | number | null) => void
}

/**
 * UI доп. курса с periodным тарифом: фиксация периода + discount_mode/цена.
 */
const StreamAdditionalCourseFields: FC<StreamAdditionalCourseFieldsProps> = ({
  tariff,
  isPeriodFixed,
  periodUnit,
  periodValue,
  discount,
  discountMode,
  price,
  streamPeriodValue,
  streamBasePrice,
  onTogglePeriodFixed,
  onChangePeriodUnit,
  onChangeValue,
  onChangeUnfixedValue,
  onChangeDiscount,
  onDiscountModeChange,
  onChangePrice,
}) => {
  return (
    <>
      <StreamAdditionalCoursePeriodFields
        isPeriodFixed={isPeriodFixed}
        periodUnit={periodUnit}
        periodValue={periodValue}
        tariff={tariff}
        onTogglePeriodFixed={onTogglePeriodFixed}
        onChangePeriodUnit={onChangePeriodUnit}
        onChangeValue={onChangeValue}
        onChangeUnfixedValue={onChangeUnfixedValue}
      />
      <StreamAdditionalCourseDiscountFields
        tariff={tariff}
        discount={discount}
        discountMode={discountMode}
        price={price}
        value={streamPeriodValue}
        basePrice={streamBasePrice}
        isPeriodFixed={isPeriodFixed}
        tariffType={tariff.type}
        onChangeDiscount={onChangeDiscount}
        onDiscountModeChange={onDiscountModeChange}
        onChangePrice={onChangePrice}
      />
    </>
  )
}

export default StreamAdditionalCourseFields
